import { ReactComponent as LargeGridIcon } from "../../Icons/grid-large.svg";
import { ReactComponent as ListIcon } from "../../Icons/list.svg";
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import {memo, useCallback, useMemo} from 'react';
import { ReactComponent as SummaryIcon } from "../../Icons/summary.svg";
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from "react-redux";
import { UIActions } from '../../Store/ViewMenuSlice';

const viewTypeItems = [
    {
        type: 'largeView',
        uid: 2,
        label:'Grid',
        icon: <LargeGridIcon edge="end" />,
    },
    /*{
        type: smallView',
        uid: 1,
        label: 'Small Grid'
        icon: <SmallGridIcon edge="end" />,
    },*/
    {
        type: 'summaryView',
        uid: 3,
        label: 'Summary',
        icon: <SummaryIcon edge="end" />,
    },
    {
        type: 'listView',
        uid: 4,
        label: 'List',
        icon: <ListIcon edge="end" />,
    }
];

const useStyles = makeStyles((theme)=> ({
    menuItem: {
        ...theme.palette.background.menu.inactive,
        "&:hover": {
            ...theme.palette.background.menu.hover,
        },
        "&:active": {
            ...theme.palette.background.menu.active,
        },
    },
    selectedMenu: {
        ...theme.palette.background.menu.active,
        "&:hover": {
            ...theme.palette.background.menu.active,
        },
    },
}));


export default memo(function ViewMenuItems({ onItemClick, excludeGridView = false }) {
    const classes = useStyles();
    const selectedViewType = useSelector((state) => state.viewMenu.viewType);
    const dispatch = useDispatch();

    const handleChangeViewType = useCallback((e) => {
        const viewType = e.currentTarget.dataset.viewType;
        dispatch(UIActions.setViewType({ viewType }));

        onItemClick?.();
    }, [dispatch, onItemClick]);

    const primaryTypographyProps = {
        variant: "subtitle1",
    };

    const displayItem = useMemo(() => 
        viewTypeItems.filter((value) => !excludeGridView || value.type !== 'largeView')
    , [excludeGridView]);

    return (
        <>
            {displayItem.map((item) =>(
                <MenuItem 
                    className={classes.menuItem + " " + (item.type === selectedViewType?classes.selectedMenu:'')} 
                    key={item.uid} onClick={handleChangeViewType} tabIndex={0}
                    data-view-type={item.type}
                >
                    <ListItemText primary={item.label} primaryTypographyProps={primaryTypographyProps}/>
                    {item.icon}
                </MenuItem>
            ))}
        </>
    );
});